import cn from 'classnames';
import IconArrowDownBold from '@creditflowresearch/uilib/Icon/IconArrowDownBold';
import UserPlanTag from '@users/ui/UserPlanTag';
import UserProfileBadge from '@creditflowresearch/uilib/UserProfileBadge';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useSessionContext } from '@users/session/SessionContext';
import UserPreferenceTip from '@/creditflowresearch/ui/common/components/organisms/UserPreferenceTip';
import LocalTimeZoneTip from '@/creditflowresearch/ui/common/components/molecules/LocalTimeZoneTip';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanPreferences } from '@/creditflowresearch/application/hooks/userPreferences/useUserPlanPreferences';

import styles from './userProfileBadgeContainer.module.scss';

interface IUserProfileBadgeContainerProps {
  isActive?: boolean,
  onClick?: () => void,
}

const UserProfileBadgeContainer = ({ isActive, onClick }: IUserProfileBadgeContainerProps) => {
  const { currentUser } = useSessionContext();
  const { plan } = useUserPlanContext();
  const { preferences, updatePreferences, hasSavedPreferences } = useUserPlanPreferences();

  const showUserPreferenceTip = UserPlan.isSatisfiedStarterPlan(plan) && !hasSavedPreferences;

  const closeUserPreferenceTip = () => {
    updatePreferences(preferences);
  };

  const handleUserProfileClick = () => {
    if (showUserPreferenceTip) {
      closeUserPreferenceTip();
    }
    onClick?.();
  };

  return (
    <div className={ styles.container }>
      <UserProfileBadge
        onClick={ handleUserProfileClick }
        displayName={ currentUser?.firstName }
        prependSibling={ (
          <IconArrowDownBold
            className={ cn(styles.icon, { [styles.iconOpen]: isActive }) }
          />
        ) }
        appendSibling={ <UserPlanTag className={ styles.planTag } fontSize={ 12 } userPlan={ plan } /> }
      />

      {
        // Only one profile-corner tip can show at a time — the preference tip takes priority;
        // the time zone tip only gets a turn once the preference tip has been dismissed.
        showUserPreferenceTip
          ? <UserPreferenceTip onClose={ closeUserPreferenceTip } />
          : <LocalTimeZoneTip isHidden={ isActive } />
      }
    </div>

  );
};

export default UserProfileBadgeContainer;
